var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1608_56936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 5.21875V3.47938C5.46875 2.78711 6.03516 2.2207 6.72742 2.2207H13.2726C13.9649 2.2207 14.5312 2.78711 14.5312 3.47938V5.21875",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6328 10.8438V17.5137C18.6328 18.1581 18.1054 18.6855 17.4609 18.6855H2.53906C1.89465 18.6855 1.36719 18.1582 1.36719 17.5137V10.8828",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 12.8164C4.30512 12.5801 0.585938 11.3984 0.585938 9.27137V6.49805C0.585938 5.85262 1.11234 5.32617 1.75781 5.32617H18.2422C18.8876 5.32617 19.4141 5.85266 19.4141 6.49805V9.27137C19.4141 11.4118 15.6479 12.5949 11.4844 12.8207",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55469 11.6543H11.4453V13.002C11.4453 13.7432 10.8389 14.3496 10.0977 14.3496H9.90234C9.16113 14.3496 8.55469 13.7432 8.55469 13.002V11.6543Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1608_56936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.bcaa0552d8ac355637e8f92d94318bb1.svg";
export { ForwardRef as ReactComponent };